import createEnum from 'scripts/lib/create_enum';

const ConversationItemType = createEnum(
  // customer initiated
  'ABANDONED_CALL',
  'CALL_FORWARD',
  'CHAT',
  'CHAT_MESSAGE',
  'CONVERSATION_MESSAGE',
  'CREDIT_CARD_VIEWED',
  'EMAIL',
  'EMAIL_PREVIEW', // used in inbox
  'INSTAGRAM_DIRECT',
  'FB_MESSAGE_INCOMING',
  'FB_MESSAGE_OUTGOING',
  'HOTEL_RESERVATION',
  'NO_REPLY_NEEDED',
  'PHONE_CALL',
  'PHONE_CALLBACK',
  'SMS',
  'TWITTER',
  'WEB_FORM',
  'VOICE_CAMPAIGN_OUTREACH',
  'VOICE_CAMPAIGN_OUTREACH_RESULT',
  'VOICEMAIL',
  // context from customer's web or mobile experiences
  'MOBILE_CONTEXT',
  'WEB_CONTEXT',
  'HELP_APP_CONTEXT',
  // rule loop detected
  'RULE_DISABLED_LOOP',
  // agent initiated
  'CONVERSATION_NOTE',
  'TASK',
  'SECURE_DATA_REQUEST',
  // task feed item
  'TASK_COMPLETION',
  'TASK_DUE',
  'TASK_EDITED',
  'TASK_REOPENED',
  'TASK_ROUTING',
  // conversation assignee change
  'ROUTING_ITEM',
  // chat feed items
  'CHAT_CUSTOMER_URL',
  'CHAT_ENDED',
  'CHAT_SELF_SERVICE_METADATA',
  'PROACTIVE_CHAT_CONTENT',
  // audit item for changing the customer assignee
  'CUSTOMER_ASSIGNEE_CHANGE',
  // email feed item
  'EMAIL_SEND_FAILURE',
  // conversation topic change
  'TOPIC_CHANGE',
  // conversation status change
  'CONVERSATION_STATUS_CHANGE',
  // audit item for ending messaging session
  'SESSION_ENDED',
  // audit item for deletion of voice recording
  'VOICE_RECORDING_DELETED',
  // linked item from another customer
  'ITEM_LINK',
  'PAYMENT_STATUS_EVENT',
  'PAYMENT_COMPLETED',
  // a conversation may have associated conversation items that have not yet been received
  // from the server; the PLACEHOLDER type is used in the interim until the actual
  // conversation item is received; the place holder is needed in order to keep
  // track of the conversation item id
  'PLACEHOLDER',
  // demo relationship item
  'NARVAR',
  // demo marketing email routing item
  'MARKETING_EMAIL',
  // external activity item
  'CUSTOMER_ACTIVITY',
  // conversation item for sessions
  'MESSAGING_SESSION'
);

export const AutomaticConversationItemTypes = [
  ConversationItemType.CREDIT_CARD_VIEWED,
  ConversationItemType.CALL_FORWARD,
  ConversationItemType.CHAT_CUSTOMER_URL,
  ConversationItemType.CHAT_SELF_SERVICE_METADATA,
  ConversationItemType.CHAT_ENDED,
  ConversationItemType.CUSTOMER_ASSIGNEE_CHANGE,
  ConversationItemType.TOPIC_CHANGE,
  ConversationItemType.CONVERSATION_STATUS_CHANGE,
  ConversationItemType.EMAIL_SEND_FAILURE,
  ConversationItemType.HELP_APP_CONTEXT,
  ConversationItemType.ITEM_LINK,
  ConversationItemType.MARKETING_EMAIL,
  ConversationItemType.MESSAGING_SESSION,
  ConversationItemType.NARVAR,
  ConversationItemType.MOBILE_CONTEXT,
  ConversationItemType.NO_REPLY_NEEDED,
  ConversationItemType.PAYMENT_STATUS_EVENT,
  ConversationItemType.PAYMENT_COMPLETED,
  ConversationItemType.ROUTING_ITEM,
  ConversationItemType.SESSION_ENDED,
  ConversationItemType.RULE_DISABLED_LOOP,
  ConversationItemType.TASK_COMPLETION,
  ConversationItemType.TASK_DUE,
  ConversationItemType.TASK_EDITED,
  ConversationItemType.TASK_ROUTING,
  ConversationItemType.TASK_REOPENED,
  ConversationItemType.VOICE_RECORDING_DELETED,
  ConversationItemType.WEB_CONTEXT,
];

export default ConversationItemType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/conversation_item_type.js